export default __webpack_public_path__ + "static/media/SummaryAnnualCarUseIcon.db5e4c1d.svg";